// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/capture_reviews.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.CaptureReviewView
 */ export class CaptureReviewView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureReviewView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureReviewView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureReviewView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureReviewView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string purpose = 4;
   */ _define_property(this, "purpose", ""), /**
   * YYYY-MM-DD or empty
   *
   * @generated from field: string review_date = 5;
   */ _define_property(this, "reviewDate", ""), /**
   * @generated from field: repeated string participants = 6;
   */ _define_property(this, "participants", []), /**
   * @generated from field: repeated string area_keys = 7;
   */ _define_property(this, "areaKeys", []), /**
   * not_assessed|not_ready|partially_ready|ready
   *
   * @generated from field: string readiness = 8;
   */ _define_property(this, "readiness", ""), /**
   * go_no_go_record_id is set only when a decision was recorded in this session.
   *
   * @generated from field: string go_no_go_record_id = 9;
   */ _define_property(this, "goNoGoRecordId", ""), /**
   * open|closed
   *
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string closure_summary = 11;
   */ _define_property(this, "closureSummary", ""), /**
   * @generated from field: string created_by = 12;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string closed_by = 14;
   */ _define_property(this, "closedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp closed_at = 15;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: int32 material_count = 16;
   */ _define_property(this, "materialCount", 0), /**
   * @generated from field: int32 finding_count = 17;
   */ _define_property(this, "findingCount", 0), /**
   * GRW-05: review | gate. Gate, date and decider are scheduling facts and are
   * never redacted.
   *
   * @generated from field: string kind = 18;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string decider_user_id = 19;
   */ _define_property(this, "deciderUserId", ""), /**
   * resolved by zou; empty when unset or unknown
   *
   * @generated from field: string decider_display_name = 20;
   */ _define_property(this, "deciderDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureReviewView, "runtime", proto3);
_define_property(CaptureReviewView, "typeName", "mono.projectdata.v1.CaptureReviewView");
_define_property(CaptureReviewView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "review_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "participants",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "area_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "readiness",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "go_no_go_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "closure_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "material_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "finding_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "decider_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "decider_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureReviewMaterialView
 */ export class CaptureReviewMaterialView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureReviewMaterialView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureReviewMaterialView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureReviewMaterialView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureReviewMaterialView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * hypothesis|artifact
   *
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", ""), /**
   * source_version identifies the version of the source that was discussed.
   *
   * @generated from field: string source_version = 5;
   */ _define_property(this, "sourceVersion", ""), /**
   * @generated from field: string version_label = 6;
   */ _define_property(this, "versionLabel", ""), /**
   * content_snapshot is the text exactly as attached; it never follows the source.
   *
   * @generated from field: string content_snapshot = 7;
   */ _define_property(this, "contentSnapshot", ""), /**
   * @generated from field: string content_sha256 = 8;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string captured_by = 9;
   */ _define_property(this, "capturedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp captured_at = 10;
   */ _define_property(this, "capturedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureReviewMaterialView, "runtime", proto3);
_define_property(CaptureReviewMaterialView, "typeName", "mono.projectdata.v1.CaptureReviewMaterialView");
_define_property(CaptureReviewMaterialView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "content_snapshot",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "captured_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "captured_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureReviewFindingView
 */ export class CaptureReviewFindingView extends Message {
    static fromBinary(bytes, options) {
        return new CaptureReviewFindingView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureReviewFindingView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureReviewFindingView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureReviewFindingView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string material_id = 3;
   */ _define_property(this, "materialId", ""), /**
   * note|minor|major|critical
   *
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string created_by = 6;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureReviewFindingView, "runtime", proto3);
_define_property(CaptureReviewFindingView, "typeName", "mono.projectdata.v1.CaptureReviewFindingView");
_define_property(CaptureReviewFindingView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureReviewsRequest
 */ export class ListCaptureReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureReviewsRequest, "runtime", proto3);
_define_property(ListCaptureReviewsRequest, "typeName", "mono.projectdata.v1.ListCaptureReviewsRequest");
_define_property(ListCaptureReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListCaptureReviewsResponse
 */ export class ListCaptureReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureReviewView reviews = 1;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureReviewsResponse, "runtime", proto3);
_define_property(ListCaptureReviewsResponse, "typeName", "mono.projectdata.v1.ListCaptureReviewsResponse");
_define_property(ListCaptureReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reviews",
            kind: "message",
            T: CaptureReviewView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureReviewRequest
 */ export class GetCaptureReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureReviewRequest, "runtime", proto3);
_define_property(GetCaptureReviewRequest, "typeName", "mono.projectdata.v1.GetCaptureReviewRequest");
_define_property(GetCaptureReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetCaptureReviewResponse
 */ export class GetCaptureReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewView review = 1;
   */ _define_property(this, "review", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureReviewMaterialView materials = 2;
   */ _define_property(this, "materials", []), /**
   * @generated from field: repeated mono.projectdata.v1.CaptureReviewFindingView findings = 3;
   */ _define_property(this, "findings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureReviewResponse, "runtime", proto3);
_define_property(GetCaptureReviewResponse, "typeName", "mono.projectdata.v1.GetCaptureReviewResponse");
_define_property(GetCaptureReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureReviewView
        },
        {
            no: 2,
            name: "materials",
            kind: "message",
            T: CaptureReviewMaterialView,
            repeated: true
        },
        {
            no: 3,
            name: "findings",
            kind: "message",
            T: CaptureReviewFindingView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CaptureReviewFields
 */ export class CaptureReviewFields extends Message {
    static fromBinary(bytes, options) {
        return new CaptureReviewFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureReviewFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureReviewFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureReviewFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string purpose = 2;
   */ _define_property(this, "purpose", ""), /**
   * YYYY-MM-DD or empty
   *
   * @generated from field: string review_date = 3;
   */ _define_property(this, "reviewDate", ""), /**
   * @generated from field: repeated string participants = 4;
   */ _define_property(this, "participants", []), /**
   * @generated from field: repeated string area_keys = 5;
   */ _define_property(this, "areaKeys", []), /**
   * empty means not_assessed
   *
   * @generated from field: string readiness = 6;
   */ _define_property(this, "readiness", ""), /**
   * optional link to a decision made in the same session
   *
   * @generated from field: string go_no_go_record_id = 7;
   */ _define_property(this, "goNoGoRecordId", ""), /**
   * GRW-05: review | gate; empty = review. A gate needs review_date.
   *
   * @generated from field: string kind = 8;
   */ _define_property(this, "kind", ""), /**
   * GRW-05: expected decider; must be an account user of this tenant.
   *
   * @generated from field: string decider_user_id = 9;
   */ _define_property(this, "deciderUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureReviewFields, "runtime", proto3);
_define_property(CaptureReviewFields, "typeName", "mono.projectdata.v1.CaptureReviewFields");
_define_property(CaptureReviewFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "review_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participants",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "area_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "readiness",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "go_no_go_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "decider_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureReviewRequest
 */ export class CreateCaptureReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewFields fields = 2;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureReviewRequest, "runtime", proto3);
_define_property(CreateCaptureReviewRequest, "typeName", "mono.projectdata.v1.CreateCaptureReviewRequest");
_define_property(CreateCaptureReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fields",
            kind: "message",
            T: CaptureReviewFields
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateCaptureReviewResponse
 */ export class CreateCaptureReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewView review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureReviewResponse, "runtime", proto3);
_define_property(CreateCaptureReviewResponse, "typeName", "mono.projectdata.v1.CreateCaptureReviewResponse");
_define_property(CreateCaptureReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureReviewView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCaptureReviewRequest
 */ export class UpdateCaptureReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCaptureReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCaptureReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCaptureReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCaptureReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewFields fields = 3;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCaptureReviewRequest, "runtime", proto3);
_define_property(UpdateCaptureReviewRequest, "typeName", "mono.projectdata.v1.UpdateCaptureReviewRequest");
_define_property(UpdateCaptureReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "fields",
            kind: "message",
            T: CaptureReviewFields
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateCaptureReviewResponse
 */ export class UpdateCaptureReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCaptureReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCaptureReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCaptureReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCaptureReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewView review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCaptureReviewResponse, "runtime", proto3);
_define_property(UpdateCaptureReviewResponse, "typeName", "mono.projectdata.v1.UpdateCaptureReviewResponse");
_define_property(UpdateCaptureReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureReviewView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureReviewMaterialRequest
 */ export class AddCaptureReviewMaterialRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureReviewMaterialRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureReviewMaterialRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureReviewMaterialRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureReviewMaterialRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * hypothesis (artifact: Unimplemented)
   *
   * @generated from field: string source_kind = 3;
   */ _define_property(this, "sourceKind", ""), /**
   * hypothesis: empty
   *
   * @generated from field: string source_id = 4;
   */ _define_property(this, "sourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureReviewMaterialRequest, "runtime", proto3);
_define_property(AddCaptureReviewMaterialRequest, "typeName", "mono.projectdata.v1.AddCaptureReviewMaterialRequest");
_define_property(AddCaptureReviewMaterialRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureReviewMaterialResponse
 */ export class AddCaptureReviewMaterialResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureReviewMaterialResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureReviewMaterialResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureReviewMaterialResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureReviewMaterialResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewMaterialView material = 1;
   */ _define_property(this, "material", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureReviewMaterialResponse, "runtime", proto3);
_define_property(AddCaptureReviewMaterialResponse, "typeName", "mono.projectdata.v1.AddCaptureReviewMaterialResponse");
_define_property(AddCaptureReviewMaterialResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "material",
            kind: "message",
            T: CaptureReviewMaterialView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureReviewFindingRequest
 */ export class AddCaptureReviewFindingRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureReviewFindingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureReviewFindingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureReviewFindingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureReviewFindingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * optional
   *
   * @generated from field: string material_id = 3;
   */ _define_property(this, "materialId", ""), /**
   * empty means note
   *
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureReviewFindingRequest, "runtime", proto3);
_define_property(AddCaptureReviewFindingRequest, "typeName", "mono.projectdata.v1.AddCaptureReviewFindingRequest");
_define_property(AddCaptureReviewFindingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "material_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddCaptureReviewFindingResponse
 */ export class AddCaptureReviewFindingResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCaptureReviewFindingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCaptureReviewFindingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCaptureReviewFindingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCaptureReviewFindingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewFindingView finding = 1;
   */ _define_property(this, "finding", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCaptureReviewFindingResponse, "runtime", proto3);
_define_property(AddCaptureReviewFindingResponse, "typeName", "mono.projectdata.v1.AddCaptureReviewFindingResponse");
_define_property(AddCaptureReviewFindingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "finding",
            kind: "message",
            T: CaptureReviewFindingView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseCaptureReviewRequest
 */ export class CloseCaptureReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CloseCaptureReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseCaptureReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseCaptureReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseCaptureReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string review_id = 2;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string closure_summary = 3;
   */ _define_property(this, "closureSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseCaptureReviewRequest, "runtime", proto3);
_define_property(CloseCaptureReviewRequest, "typeName", "mono.projectdata.v1.CloseCaptureReviewRequest");
_define_property(CloseCaptureReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "closure_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CloseCaptureReviewResponse
 */ export class CloseCaptureReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new CloseCaptureReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseCaptureReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseCaptureReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseCaptureReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.CaptureReviewView review = 1;
   */ _define_property(this, "review", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseCaptureReviewResponse, "runtime", proto3);
_define_property(CloseCaptureReviewResponse, "typeName", "mono.projectdata.v1.CloseCaptureReviewResponse");
_define_property(CloseCaptureReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: CaptureReviewView
        }
    ]));
